// eslint-disable-next-line @typescript-eslint/no-this-alias
const globalContext = window;

export const currentLang = globalContext && globalContext.localStorage.i18nextLng;
